import { useEffect, useState } from 'react';
import { scrollToSection as scrollToSectionUtil } from '@/utils/scroll';

export function useHeader() {
  const [isMenuOpen, setIsMenuOpen] = useState(false);
  const [isScrolled, setIsScrolled] = useState(false);

  useEffect(() => {
    const handleScroll = () => {
      setIsScrolled(window.scrollY > 20);
    };

    handleScroll();
    window.addEventListener('scroll', handleScroll);
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);

  useEffect(() => {
    const updateScrollOffset = () => {
      const header = document.querySelector('header');
      if (!header) return;

      const headerHeight = Math.round(header.getBoundingClientRect().height + 16);
      document.documentElement.style.setProperty('--scroll-offset', `${headerHeight}px`);
    };

    updateScrollOffset();
    window.addEventListener('resize', updateScrollOffset);

    return () => {
      window.removeEventListener('resize', updateScrollOffset);
    };
  }, []);

  const scrollToSection = (href: string) => {
    scrollToSectionUtil(href, {
      onComplete: () => {
        setIsMenuOpen(false);
      },
    });
  };

  const toggleMenu = () => {
    setIsMenuOpen((prev) => !prev);
  };

  const closeMenu = () => {
    setIsMenuOpen(false);
  };

  const hasBackground = isScrolled || isMenuOpen;

  return {
    isMenuOpen,
    isScrolled,
    hasBackground,
    scrollToSection,
    toggleMenu,
    closeMenu,
  };
}
